import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/Plans.css";

const Plans = () => {
  const navigate = useNavigate();

  const handleSelectPlan = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } else {
      navigate("/checkout");
    }
  };

  return (
    <div className="plans-page">
      <div className="logo" onClick={() => navigate("/")}>
        TOEICMON
      </div>
      <div className="plans-header">
        <h1>요금제 선택</h1>
        <p>토익 준비를 위한 최적의 요금제를 선택하세요</p>
      </div>

      <div className="plans-container">
        <div className="plan-card featured">
          <div className="plan-name">1개월 이용권</div>
          <div className="plan-price">
            <span className="price">59,000원</span>
            <span className="period">/월</span>
          </div>
          <ul className="plan-features">
            <li>✔️ 1,000개 이상의 문제 접근 가능</li>
            <li>✔️ 상세한 답변 및 설명</li>
            <li>✔️ 문제 풀이 시간 추적 기능</li>
            <li>✔️ 학습 진도 저장 및 관리</li>
            <li>✔️ 언제든지 해지 가능</li>
          </ul>
          <button className="plan-select-btn" onClick={handleSelectPlan}>
            시작하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default Plans;
